// extracted by mini-css-extract-plugin
module.exports = {"section":"Content_section__3LO0m","dateSelected":"Content_dateSelected__1G7k1"};